module.exports = __webpack_public_path__ + "components/MapControl/svg/Port_przystań.svg?76fa0e9d";


//////////////////
// WEBPACK FOOTER
// ./components/MapControl/svg/Port_przystań.svg
// module id = 2082
// module chunks = 0